import React, { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { FILE_EXPLORER_OPTIONS } from './constants';
import DifferenceSelection from './difference-selection';

interface OptionSelectProps {
  selectedOption: string;
  setOption: (option: string) => void;
  filesSelected: Array<any>;
}

interface Option {
  name: string;
  disabled: boolean;
}

const OptionSelect = ({
  selectedOption, 
  setOption,
  filesSelected
}: OptionSelectProps) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOption((event.target as HTMLInputElement).value);
  };

  const [ processingOptions, setProcessingOptions ] = useState<Array<Option>>([
    {
      name: FILE_EXPLORER_OPTIONS.NONE,
      disabled: false,
    }, 
    {
      name: FILE_EXPLORER_OPTIONS.CALC_DIFF,
      disabled: false
    }, {
      name: FILE_EXPLORER_OPTIONS.CHARTS,
      disabled: false,
    }
  ]);

  useEffect(()=> {
    setOption(FILE_EXPLORER_OPTIONS.NONE);
  },[])

  useEffect(() => {
    const validOptions = [{
      name: FILE_EXPLORER_OPTIONS.NONE,
      disabled: false
    }];
    if (filesSelected.length === 1) {
      validOptions.push({
        name: FILE_EXPLORER_OPTIONS.CALC_DIFF,
        disabled: true,
      },
      {
        name: FILE_EXPLORER_OPTIONS.CHARTS,
        disabled: false,
      });
    } else if (filesSelected.length >= 2){
      validOptions.push({
        name: FILE_EXPLORER_OPTIONS.CALC_DIFF,
        disabled: false,
      },
      {
        name: FILE_EXPLORER_OPTIONS.CHARTS,
        disabled: true,
      });
    }else{
      validOptions.push({
        name: FILE_EXPLORER_OPTIONS.NONE,
        disabled: false
      },
      {
        name: FILE_EXPLORER_OPTIONS.CALC_DIFF,
        disabled: true,
      },
      {
        name: FILE_EXPLORER_OPTIONS.CHARTS,
        disabled: true,
      });
    }
    setProcessingOptions(validOptions);

  },[filesSelected]);
  
  return (
    <FormControl>
      <FormLabel id="demo-controlled-radio-buttons-group">Processing Option</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={selectedOption}
        defaultValue={selectedOption}
        onChange={handleChange}
      >
        {processingOptions?.map((option) => 
          <FormControlLabel 
            value={option.name} 
            control={<Radio />} 
            label={option.name} 
            disabled={option.disabled}/>
        )}
      </RadioGroup>
    </FormControl>
  );
}

export default OptionSelect;